var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIceBucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 70,
    viewBox: "0 0 219 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_873_171773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7604 16.3456L11.2292 11.9477L9.47919 16.8587L12.7604 16.3456Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7603 16.3456L14.0728 13.7801L11.2291 11.9477L12.7603 16.3456Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0728 13.7801L12.3958 11.1413L11.2291 11.9476L14.0728 13.7801Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4165 17.2252L20.854 11.6545L14.0728 13.7801L20.4165 17.2252Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2084 12.021L20.7813 11.6545L20.4167 17.2252L24.2084 12.021Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5938 14.5131L24.2084 12.0209L20.4167 17.2251L25.5938 14.5131Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2083 12.021L22.1667 11.2147L20.7812 11.6545L24.2083 12.021Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2708 17.6649L34.7083 15.979L32.0103 14.4398L34.2708 17.6649Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7083 15.9791L38.7188 11.3613L32.0833 14.4398L34.7083 15.9791Z",
    fill: "#CBEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5417 14.5131L38.7188 11.4345L34.7084 16.0523L40.5417 14.5131Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5417 14.5131L34.7083 16.0524L34.2708 17.6649L40.5417 14.5131Z",
    fill: "#91ACB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.021 17.3718L58.4064 15.0262L51.5522 15.9058L57.021 17.3718Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.021 17.5184V17.2985L51.5522 15.8325L57.021 17.5184Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5522 15.9058L58.4064 15.0262L51.5522 15.9058Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7606 16.7854L58.4064 14.9529L57.021 17.2985L61.7606 16.7854Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7604 16.7853L63.875 11.2879L58.3333 14.9529L61.7604 16.7853Z",
    fill: "#CBEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2606 12.3874L63.8752 11.2879L61.7606 16.7853L65.2606 12.3874Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1147 17.8115L65.2606 12.4607L61.7606 16.8586L65.1147 17.8115Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4894 13.7801L65.2603 12.3875L65.1144 17.7383L69.4894 13.7801Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9481 11.2879L65.3335 12.3874L63.9481 11.2879Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4896 13.7801L70.9479 12.9006L65.2604 12.3875L69.4896 13.7801Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7603 15.6126L70.9478 12.9005L69.4894 13.7801L75.7603 15.6126Z",
    fill: "#C5DCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8124 14.8796L81.6666 13.7801L75.7603 15.5393L81.8124 14.8796Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8125 14.8796L82.1771 14.5131L81.6667 13.7801L81.8125 14.8796Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1771 14.5131L87.0625 12.6807L81.6667 13.8534L82.1771 14.5131Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3647 15.6126V15.3194L94.9377 14.5131L98.3647 15.6126Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3645 15.6126L103.104 15.9058L98.3645 15.3194V15.6126Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.177 15.9058L104.125 14.3665L98.4375 15.3194L103.177 15.9058Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.094 15.7591L104.052 14.4398L103.104 15.979L106.094 15.7591Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.094 15.7592L105.583 12.0943L104.052 14.4398L106.094 15.7592Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.094 15.7592L108.062 11.5079L105.583 12.021L106.094 15.7592Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.927 14.8063L107.99 11.5079L106.021 15.7592L111.927 14.8063Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 15.0994V14.8062L106.167 15.6858L112 15.0994Z",
    fill: "#CBEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.417 17.8115L111.927 15.1728L106.021 15.7591L111.417 17.8115Z",
    fill: "#CBEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.26 14.9529L112 15.0995L111.49 17.7382L114.26 14.9529Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 15.0994L114.26 14.9528L112 14.8062V15.0994Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.156 17.8115L121.042 12.7539L120.24 14.0733L123.156 17.8115Z",
    fill: "#D2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.156 17.8115L122.646 11.6545L121.042 12.7539L123.156 17.8115Z",
    fill: "#7894A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.156 17.8115L125.854 17.6649L122.646 11.6545L123.156 17.8115Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2291 11.9477L12.3958 11.1414L11.2291 7.91624V11.9477Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.604 6.59689L11.9582 5.20422L11.1561 7.91626L15.604 6.59689Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3957 11.1414L15.604 6.59686L11.1561 7.91623L12.3957 11.1414Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6041 6.5969L13.1249 2.93198L11.9583 5.20423L15.6041 6.5969Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0729 13.7801L15.6042 6.59686L12.3958 11.1414L14.0729 13.7801Z",
    fill: "#B2D1ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7811 11.6544L15.604 6.59686L14.0728 13.7801L20.7811 11.6544Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6042 6.59688L14 1.75919L13.125 2.93196L15.6042 6.59688Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6043 6.59688L21.0002 4.76442L14.0002 1.75919L15.6043 6.59688Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7812 11.6545L20.9999 4.76442L15.6041 6.59688L20.7812 11.6545Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 11.2147L21 4.76442L20.7812 11.6545L22.1667 11.2147Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1666 11.2147L24.9374 10.4817L21.0728 4.76442L22.1666 11.2147Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9374 10.4817L25.8853 3.59163L20.9999 4.69111L24.9374 10.4817Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5418 4.03142L25.8856 3.59163L24.9377 10.4817L26.5418 4.03142Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8853 3.59161L24.427 2.56543L21.0728 4.69108L25.8853 3.59161Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2083 12.0209L24.9374 10.4817L22.1666 11.2147L24.2083 12.0209Z",
    fill: "#8CA8BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7085 9.8953L26.5418 4.03143L24.9377 10.4817L27.7085 9.8953Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7085 9.89529L24.9377 10.4817L24.2085 12.0209L27.7085 9.89529Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5939 14.513L27.7085 9.96854L24.2085 12.0209L25.5939 14.513Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5417 4.03145L31.6459 1.90579L25.8854 3.66495L26.5417 4.03145Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4272 14L27.7084 9.89529L25.5938 14.4398L31.4272 14Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7083 9.89526L33.6145 5.64395L26.5416 3.95808L27.7083 9.89526Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.25 8.7958L33.5417 5.71726L27.7083 9.89527L33.25 8.7958Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6145 5.71731L31.6458 1.90579L26.5416 4.03145L33.6145 5.71731Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4271 14L33.25 8.79584L27.7083 9.89531L31.4271 14Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6876 8.5759L33.6147 5.71726L33.2501 8.7958L33.6876 8.5759Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0105 14.4398L33.2501 8.79584L31.4272 14L32.0105 14.4398Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6876 8.5759L34.2709 8.06281L33.6147 5.71726L33.6876 8.5759Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7187 11.3613L33.2499 8.79584L32.0103 14.4398L38.7187 11.3613Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6145 5.71728V0L31.6458 1.90576L33.6145 5.71728Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6979 1.68586L33.6146 0L33.5417 5.71728L37.6979 1.68586Z",
    fill: "#7AC2CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7188 11.3612L33.6876 8.5759L33.2501 8.79579L38.7188 11.3612Z",
    fill: "#CBEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7189 11.3613L34.271 8.06284L33.6877 8.57593L38.7189 11.3613Z",
    fill: "#CBEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7188 11.3613L38.9375 10.7749L34.2708 8.06284L38.7188 11.3613Z",
    fill: "#C5DCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2709 8.06287L40.5417 3.22517L33.6147 5.71732L34.2709 8.06287Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5418 3.2251L37.771 1.68584L33.6877 5.64395L40.5418 3.2251Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9375 10.7749L40.5417 3.22517L34.2708 8.06287L38.9375 10.7749Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4583 6.30371L40.5416 3.22517L38.9374 10.7749L43.4583 6.30371Z",
    fill: "#9FB6BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5416 14.5131L41.7083 14.6597L38.9374 10.7749L40.5416 14.5131Z",
    fill: "#C5DCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1874 7.18324L43.4583 6.30366L38.9374 10.7016L44.1874 7.18324Z",
    fill: "#D2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5418 14.5131L38.9376 10.7749L38.7188 11.3613L40.5418 14.5131Z",
    fill: "#C5DCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6353 14.6596L44.1144 7.25651L38.8644 10.7748L41.6353 14.6596Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0209 15.0995L44.1876 7.18325L41.6355 14.6597L43.0209 15.0995Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4584 6.30368L47.6147 1.17279L40.5417 3.22515L43.4584 6.30368Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.625 15.9791L44.1875 7.18325L43.0208 15.0995L44.625 15.9791Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6251 15.9791L51.4793 10.4817L44.1876 7.18325L44.6251 15.9791Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7084 5.2042L47.5417 1.17279L43.3854 6.30368L48.7084 5.2042Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4792 10.4817L51.1146 8.72252L44.1146 7.18325L51.4792 10.4817Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1876 7.18327L48.7084 5.20422L43.4584 6.30369L44.1876 7.18327Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.552 15.8325V10.4817L44.6978 15.9791L51.552 15.8325Z",
    fill: "#C5DCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1876 8.72254L48.7084 5.20422L44.1876 7.18327L51.1876 8.72254Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7085 5.2042L61.1043 4.76441L47.5418 1.17279L48.7085 5.2042Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1043 4.76441L62.1251 1.53928L47.5418 1.17279L61.1043 4.76441Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1874 8.72254L60.0832 7.10997L48.7082 5.20422L51.1874 8.72254Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0832 7.10997L61.104 4.76442L48.7082 5.20421L60.0832 7.10997Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5522 15.8325L58.4063 15.0262L51.4792 10.4817L51.5522 15.8325Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4793 10.4817L60.0835 7.18325L51.1877 8.79582L51.4793 10.4817Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4063 14.9528L60.0834 7.10991L51.4792 10.4083L58.4063 14.9528Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6355 9.96859L60.0834 7.18325L58.4063 15.0262L62.6355 9.96859Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1459 10.3351L62.6355 9.89529L58.4063 14.9529L63.1459 10.3351Z",
    fill: "#CBEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.948 11.288L63.2188 10.3351L58.4063 14.9529L63.948 11.288Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9481 11.288L63.2189 10.3351L63.9481 11.288Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6353 3.5183L62.1249 1.53925L61.104 4.76438L62.6353 3.5183Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6353 9.96856L61.0311 4.83767L60.0103 7.18322L62.6353 9.96856Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6354 9.96859L67.4479 5.0576L62.6354 3.59163V9.96859Z",
    fill: "#B2D1ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6353 9.96859V3.59163L61.104 4.8377L62.6353 9.96859Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1458 10.3351L67.4479 5.05762L62.6354 9.96861L63.1458 10.3351Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5938 5.20421L67.448 5.05762L63.1459 10.3351L67.5938 5.20421Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6353 3.5183L67.8853 1.68584L62.1978 1.53925L62.6353 3.5183Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4478 5.05756L67.8124 1.68584L62.5624 3.5183L67.4478 5.05756Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8751 11.288L67.5938 5.20422L63.1459 10.4084L63.8751 11.288Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2605 12.3874L67.5938 5.13087L63.8751 11.2146L65.2605 12.3874Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2917 6.23039L67.5938 5.20422L65.2604 12.4608L70.2917 6.23039Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9479 12.9006L70.2917 6.23041L65.2604 12.3875L70.9479 12.9006Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5938 5.20416L67.8125 1.68584L67.4479 5.05756L67.5938 5.20416Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2915 6.23034L67.8853 1.68584L67.6665 5.20416L70.2915 6.23034Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2917 6.23034L72.9167 2.85861L67.8125 1.68584L70.2917 6.23034Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9167 2.8586L70.9479 0.513046L67.8125 1.61252L72.9167 2.8586Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9478 12.9006L74.0833 8.57596L70.2916 6.23041L70.9478 12.9006Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.948 12.9006L144.083 8.57596L140.292 6.23041L140.948 12.9006Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0312 3.88481L72.9166 2.85863L70.2916 6.23036L75.0312 3.88481Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.031 3.88481L142.917 2.85863L140.292 6.23036L145.031 3.88481Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0833 8.57593L75.0312 3.88483L70.2916 6.23038L74.0833 8.57593Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.083 8.57593L145.031 3.88483L140.292 6.23038L144.083 8.57593Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7603 15.6125L74.0832 8.5759L70.9478 12.9005L75.7603 15.6125Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.76 15.6125L144.083 8.5759L140.948 12.9005L145.76 15.6125Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7605 15.6125L77.6563 8.4293L74.0834 8.5759L75.7605 15.6125Z",
    fill: "#49738C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.761 15.6125L147.656 8.4293L144.083 8.5759L145.761 15.6125Z",
    fill: "#49738C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3855 5.71729L75.0313 3.88483L74.0834 8.57593L78.3855 5.71729Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.386 5.71729L145.031 3.88483L144.083 8.57593L148.386 5.71729Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6563 8.4293L78.3125 5.71726L74.0104 8.5759L77.6563 8.4293Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.656 8.4293L148.313 5.71726L144.01 8.5759L147.656 8.4293Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6666 13.7801L77.6562 8.35604L75.7603 15.5393L81.6666 13.7801Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.667 13.7801L147.656 8.35604L145.76 15.5393L151.667 13.7801Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3854 5.71723L77.0729 3.51828L75.0312 3.88477L78.3854 5.71723Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.385 5.71723L147.073 3.51828L145.031 3.88477L148.385 5.71723Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6668 13.7801L82.4688 8.72253L77.7292 8.35604L81.6668 13.7801Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.667 13.7801L152.469 8.72253L147.729 8.35604L151.667 13.7801Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3856 5.71723L88.0106 4.10467L77.0731 3.51828L78.3856 5.71723Z",
    fill: "#AFC5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.386 5.71723L158.011 4.10467L147.073 3.51828L148.386 5.71723Z",
    fill: "#AFC5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7917 4.83766L88.0834 4.10468L78.4584 5.71724L87.7917 4.83766Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.792 4.83766L158.083 4.10468L148.458 5.71724L157.792 4.83766Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4688 8.7958L78.3855 5.71726L77.7292 8.4293L82.4688 8.7958Z",
    fill: "#C5DCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.469 8.7958L148.386 5.71726L147.729 8.4293L152.469 8.7958Z",
    fill: "#C5DCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4688 8.79578L87.7917 4.83767L78.3854 5.71725L82.4688 8.79578Z",
    fill: "#CBEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.469 8.79578L157.792 4.83767L148.385 5.71725L152.469 8.79578Z",
    fill: "#CBEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0625 12.6807L82.4688 8.79584L81.6667 13.8534L87.0625 12.6807Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.063 12.6807L152.469 8.79584L151.667 13.8534L157.063 12.6807Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0625 12.6806L87.7188 4.83767L82.3958 8.79579L87.0625 12.6806Z",
    fill: "#94B9D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.063 12.6806L157.719 4.83767L152.396 8.79579L157.063 12.6806Z",
    fill: "#94B9D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3334 7.62301L87.7917 4.83767L87.1354 12.6806L93.3334 7.62301Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.333 7.62301L157.792 4.83767L157.135 12.6806L163.333 7.62301Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3333 7.62305L89.4687 4.17802L87.7916 4.83771L93.3333 7.62305Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.333 7.62305L159.469 4.17802L157.792 4.83771L163.333 7.62305Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0416 14.5864L93.3333 7.62305L87.0624 12.6806L93.0416 14.5864Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.042 14.5864L163.333 7.62305L157.062 12.6806L163.042 14.5864Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4687 4.17797L88.0833 4.10468L87.7916 4.83766L89.4687 4.17797Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.469 4.17797L158.083 4.10468L157.792 4.83766L159.469 4.17797Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2605 14.5864L93.3334 7.6963L93.0417 14.6597L93.2605 14.5864Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.261 14.5864L163.333 7.6963L163.042 14.6597L163.261 14.5864Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3335 7.62305L97.0522 1.17279L89.4689 4.17803L93.3335 7.62305Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.333 7.62305L167.052 1.17279L159.469 4.17803L163.333 7.62305Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9374 8.13614L93.3333 7.62305L93.2603 14.5131L94.9374 8.13614Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.937 8.13614L163.333 7.62305L163.26 14.5131L164.937 8.13614Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9374 14.5131L94.8645 8.1361L93.1874 14.5131H94.9374Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.937 14.5131L164.864 8.1361L163.187 14.5131H164.937Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9375 8.13614L97.0521 1.17279L93.3333 7.62305L94.9375 8.13614Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.938 8.13614L167.052 1.17279L163.333 7.62305L164.938 8.13614Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5835 7.98954L97.0522 1.17279L94.9377 8.13614L98.5835 7.98954Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.583 7.98954L167.052 1.17279L164.938 8.13614L168.583 7.98954Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9377 14.5131L98.5835 7.9895L94.9377 8.1361V14.5131Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.938 14.5131L168.583 7.9895L164.938 8.1361V14.5131Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.406 9.08898L98.5833 7.9895L98.3645 15.3193L100.406 9.08898Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.406 9.08898L168.583 7.9895L168.365 15.3193L170.406 9.08898Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3647 15.3193L98.5835 7.9895L94.9377 14.5131L98.3647 15.3193Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.365 15.3193L168.583 7.9895L164.938 14.5131L168.365 15.3193Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5834 7.98954L105.583 2.71206L97.0522 1.17279L98.5834 7.98954Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.583 7.98954L175.583 2.71206L167.052 1.17279L168.583 7.98954Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.406 9.089L105.583 2.71204L98.5835 7.98952L100.406 9.089Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.406 9.089L175.583 2.71204L168.583 7.98952L170.406 9.089Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.052 14.3665L100.406 9.08904L98.3645 15.3194L104.052 14.3665Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 14.3665L170.406 9.08904L168.365 15.3194L174.052 14.3665Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.052 14.3665L105.583 12.021L100.406 9.08904L104.052 14.3665Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.052 14.3665L175.583 12.021L170.406 9.08904L174.052 14.3665Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.771 7.54973L105.583 2.71204L100.406 9.089L107.771 7.54973Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.771 7.54973L175.584 2.71204L170.406 9.089L177.771 7.54973Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.583 12.0209L107.771 7.54971L100.406 9.08897L105.583 12.0209Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.584 12.0209L177.771 7.54971L170.406 9.08897L175.584 12.0209Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.062 11.5078L107.771 7.54971L105.583 12.0209L108.062 11.5078Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.062 11.5078L177.771 7.54971L175.583 12.0209L178.062 11.5078Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.771 7.54977L109.448 2.93197L105.583 2.78537L107.771 7.54977Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.771 7.54977L179.448 2.93197L175.583 2.78537L177.771 7.54977Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.614 4.91103L109.448 2.93198L107.771 7.54978L110.614 4.91103Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.614 4.91103L179.448 2.93198L177.771 7.54978L180.614 4.91103Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.062 11.5078L115.573 9.01567L107.844 7.54971L108.062 11.5078Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.062 11.5078L185.573 9.01567L177.844 7.54971L178.062 11.5078Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.5 9.01573L110.614 4.91102L107.771 7.54976L115.5 9.01573Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5 9.01573L180.614 4.91102L177.771 7.54976L185.5 9.01573Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.615 4.91103L110.396 3.51836L109.448 2.93198L110.615 4.91103Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.615 4.91103L180.396 3.51836L179.448 2.93198L180.615 4.91103Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.927 14.8063L115.5 9.01569L107.99 11.5078L111.927 14.8063Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.927 14.8063L185.5 9.01569L177.99 11.5078L181.927 14.8063Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.26 14.9529L115.5 9.01569L111.927 14.8063L114.26 14.9529Z",
    fill: "#C5DCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.26 14.9529L185.5 9.01569L181.927 14.8063L184.26 14.9529Z",
    fill: "#C5DCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.156 9.67538L115.5 9.01569L114.261 14.9529L116.156 9.67538Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.156 9.67538L185.5 9.01569L184.261 14.9529L186.156 9.67538Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.5 9.01573L116.448 7.91625L110.615 4.91102L115.5 9.01573Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5 9.01573L186.448 7.91625L180.615 4.91102L185.5 9.01573Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.615 4.91095L116.448 7.91619L110.396 3.51828L110.615 4.91095Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.615 4.91095L186.448 7.91619L180.396 3.51828L180.615 4.91095Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.448 7.9162L120.604 1.24605L110.396 3.445L116.448 7.9162Z",
    fill: "#C5DCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.448 7.9162L190.604 1.24605L180.396 3.445L186.448 7.9162Z",
    fill: "#C5DCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.24 14.0733L116.156 9.67543L114.188 14.9529L120.24 14.0733Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.24 14.0733L186.156 9.67543L184.188 14.9529L190.24 14.0733Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.239 14.0733L121.042 12.754L116.156 9.67543L120.239 14.0733Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.239 14.0733L191.042 12.754L186.156 9.67543L190.239 14.0733Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.156 9.67538L117.25 8.7225L115.5 9.01569L116.156 9.67538Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.156 9.67538L187.25 8.7225L185.5 9.01569L186.156 9.67538Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.25 8.72253L116.448 7.91624L115.5 9.01572L117.25 8.72253Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.25 8.72253L186.448 7.91624L185.5 9.01572L187.25 8.72253Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.25 8.72249L120.604 1.24605L116.448 7.91621L117.25 8.72249Z",
    fill: "#CBEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.25 8.72249L190.604 1.24605L186.448 7.91621L187.25 8.72249Z",
    fill: "#CBEAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.042 12.7539L117.25 8.7225L116.156 9.67538L121.042 12.7539Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.042 12.7539L187.25 8.7225L186.156 9.67538L191.042 12.7539Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.177 4.61783L120.604 1.3194L117.25 8.79584L124.177 4.61783Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.177 4.61783L190.604 1.3194L187.25 8.79584L194.177 4.61783Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.864 10.555L124.177 4.61782L117.25 8.72253L122.864 10.555Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.864 10.555L194.177 4.61782L187.25 8.72253L192.864 10.555Z",
    fill: "#97AFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.042 12.7539L122.864 10.555L117.25 8.7225L121.042 12.7539Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.042 12.7539L192.864 10.555L187.25 8.7225L191.042 12.7539Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.646 11.5811L122.865 10.5549L121.042 12.7539L122.646 11.5811Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.646 11.5811L192.865 10.5549L191.042 12.7539L192.646 11.5811Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.833 10.7749L124.177 4.61782L122.865 10.555L124.833 10.7749Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.833 10.7749L194.177 4.61782L192.865 10.555L194.833 10.7749Z",
    fill: "#AFD2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.854 17.6649L124.833 10.7749L122.646 11.6545L125.854 17.6649Z",
    fill: "#D2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.854 17.6649L194.833 10.7749L192.646 11.6545L195.854 17.6649Z",
    fill: "#D2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.854 17.6649L127.969 11.8744L124.76 10.7749L125.854 17.6649Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.854 17.6649L197.969 11.8744L194.76 10.7749L195.854 17.6649Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.833 10.7749L122.865 10.6283L122.646 11.6545L124.833 10.7749Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.833 10.7749L192.865 10.6283L192.646 11.6545L194.833 10.7749Z",
    fill: "#BEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.271 4.03138L131.469 1.39264L124.104 4.61777L132.271 4.03138Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.271 4.03138L201.469 1.39264L194.104 4.61777L202.271 4.03138Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.979 5.4241L132.271 4.03143L124.177 4.61781L131.979 5.4241Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.979 5.4241L202.271 4.03143L194.177 4.61781L201.979 5.4241Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.833 10.7749L128.042 11.8744L124.25 4.61782L124.833 10.7749Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.833 10.7749L198.042 11.8744L194.25 4.61782L194.833 10.7749Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.042 11.8744L131.979 5.4241L124.177 4.61782L128.042 11.8744Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.042 11.8744L201.979 5.4241L194.177 4.61782L198.042 11.8744Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.354 11.801L131.979 5.42406L128.042 11.8743L129.354 11.801Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.354 11.801L201.979 5.42406L198.042 11.8743L199.354 11.801Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.479 10.0419L131.979 5.42406L129.354 11.801L135.479 10.0419Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.479 10.0419L201.979 5.42406L199.354 11.801L205.479 10.0419Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.5 12.6806L135.479 10.0419L129.281 11.801L136.5 12.6806Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.5 12.6806L205.479 10.0419L199.281 11.801L206.5 12.6806Z",
    fill: "#9BBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.281 10.0419L132.271 4.03143L131.979 5.4241L136.281 10.0419Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.281 10.0419L202.271 4.03143L201.979 5.4241L206.281 10.0419Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.479 10.0419H136.281L131.906 5.42406L135.479 10.0419Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.479 10.0419H206.281L201.906 5.42406L205.479 10.0419Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.281 10.0419L140 2.78537L132.271 4.03144L136.281 10.0419Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.281 10.0419L210 2.78537L202.271 4.03144L206.281 10.0419Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 2.78534L137.812 0.293198L132.271 4.03142L140 2.78534Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 2.78534L207.812 0.293198L202.271 4.03142L210 2.78534Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.208 6.81678L140 2.78537L136.281 10.0419L143.208 6.81678Z",
    fill: "#D2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.208 6.81678L210 2.78537L206.281 10.0419L213.208 6.81678Z",
    fill: "#D2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.229 10.9215L136.281 10.0419H135.479L137.229 10.9215Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.229 10.9215L206.281 10.0419H205.479L207.229 10.9215Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.5 12.6806L137.229 10.9215L135.479 10.0419L136.5 12.6806Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.5 12.6806L207.229 10.9215L205.479 10.0419L206.5 12.6806Z",
    fill: "#7792A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.229 10.9214L143.135 6.81671L136.281 10.0418L137.229 10.9214Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.229 10.9214L213.135 6.81671L206.281 10.0418L207.229 10.9214Z",
    fill: "#90B2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.208 9.60209V6.74345L137.302 10.8482L143.208 9.60209Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.208 9.60209V6.74345L207.302 10.8482L213.208 9.60209Z",
    fill: "#B5E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.729 19.8638L144.156 10.7015L136.427 12.6806L140.729 19.8638Z",
    fill: "#D2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.729 19.8638L214.156 10.7015L206.427 12.6806L210.729 19.8638Z",
    fill: "#D2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.229 10.7015L137.229 10.9214L136.5 12.6806L144.229 10.7015Z",
    fill: "#D2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.229 10.7015L207.229 10.9214L206.5 12.6806L214.229 10.7015Z",
    fill: "#D2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.229 10.7016L143.208 9.60209L137.229 10.8482L144.229 10.7016Z",
    fill: "#C6EBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.229 10.7016L213.208 9.60209L207.229 10.8482L214.229 10.7016Z",
    fill: "#C6EBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.427 20.0837L144.229 10.7015L140.729 19.8638L143.427 20.0837Z",
    fill: "#7894A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.427 20.0837L214.229 10.7015L210.729 19.8638L213.427 20.0837Z",
    fill: "#7894A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.031 19.6439L144.229 10.7015L143.427 20.0837L145.031 19.6439Z",
    fill: "#D2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.031 19.6439L214.229 10.7015L213.427 20.0837L215.031 19.6439Z",
    fill: "#D2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.677 21.623C218.677 22.0628 218.385 22.4293 218.021 22.5759L208.688 25.3613C208.688 25.3613 208.615 25.6544 208.542 26.0209C208.323 26.8272 208.031 28.1466 207.74 29.1728C207.667 29.466 207.594 29.8325 207.521 29.9791C207.156 31.6649 206.135 32.6911 205.26 32.7644C203.875 32.8377 202.271 32.7644 202.271 32.7644C202.271 32.7644 198.625 51.822 197.896 65.089C197.75 68.0942 194.396 70 189.875 70C165.302 70 53.4479 70 28.875 70C24.3542 70 21 68.0942 20.8542 65.089C20.125 51.822 16.4792 32.7644 16.4792 32.7644C16.4792 32.7644 14.875 32.8377 13.4896 32.7644C12.6146 32.6911 11.5208 31.5916 11.2292 29.9791C11.1562 29.7592 11.1563 29.466 11.0104 29.1728C10.7917 28.2199 10.4271 26.8272 10.2083 26.0209C10.1354 25.5811 10.0625 25.3613 10.0625 25.3613L0.729167 22.5759C0.291667 22.4293 0 21.9895 0 21.5497C0.0729167 20.0105 0.21875 16.4921 0.21875 13.7068C0.21875 9.96858 4.08333 9.74869 4.08333 9.74869H214.667C214.667 9.74869 218.531 9.96858 218.531 13.7068C218.458 16.4921 218.604 20.0838 218.677 21.623Z",
    fill: "#54BCE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.9895 25.288H18.8124L24.0624 64.356C24.0624 64.356 23.4791 70.8063 36.2395 69.9267H28.8749C28.8749 69.9267 21.1458 70.0733 20.8541 65.0157C20.4895 59.3717 19.7603 51.3089 16.4791 32.7644C16.4791 32.7644 15.0208 32.8377 13.4895 32.7644C12.3958 32.6911 11.5208 31.445 11.1562 29.9791C10.4999 27.3403 9.9895 25.288 9.9895 25.288Z",
    fill: "#190A0B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M4.01041 9.67543L2.69791 16.0524C2.04166 19.2775 3.42708 22.7226 6.41666 24.1885C6.70833 24.3351 6.92708 24.4084 7.21875 24.4817L0.656247 22.576C0.656247 22.576 -0.145836 22.4294 -0.0729197 21.5498C-3.01749e-06 20.6702 0.14583 13.1205 0.14583 13.1205C0.14583 13.1205 0.218747 10.1885 4.01041 9.67543Z",
    fill: "#190A0B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M208.469 25.288H196.51L191.333 64.356C191.333 64.356 190.823 69.1204 182.292 69.9267H189.656C189.656 69.9267 197.385 70.0733 197.677 65.0157C198.042 59.3717 198.771 51.3089 202.052 32.7644C202.052 32.7644 203.51 32.8377 205.042 32.7644C206.135 32.6911 207.01 31.445 207.375 29.9791C207.958 27.3403 208.469 25.288 208.469 25.288Z",
    fill: "#190A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2084 24.9214H208.652L208.542 25.6544H10.3744L10.2084 24.9214Z",
    fill: "#3185A6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M214.74 9.67543V20.3037C214.74 20.3037 214.229 23.6754 211.458 24.4817L218.021 22.576C218.021 22.576 218.823 22.4294 218.75 21.5498C218.677 20.6702 218.531 13.1205 218.531 13.1205C218.531 13.1205 218.531 10.1885 214.74 9.67543Z",
    fill: "#190A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.469 25.5208C208.396 26.4004 207.594 27.6465 207.448 28.6727H10.9375C10.7187 27.7198 10.3542 26.3271 10.1354 25.5208L208.469 25.5208Z",
    fill: "#4898B8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.4181 70H42.2917L38.1224 28.4375H18.9583L23.7859 64.9916C24.1517 67.8322 26.5654 70 29.4181 70Z",
    fill: "#328EB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.6458 25.288H38.2813L37.4063 9.67543H16.7708L17.6458 25.288Z",
    fill: "#328EB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_873_171773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 218.75,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceBucket);
export default __webpack_public_path__ + "static/media/ice_bucket.c997df417a716dae0fa2a89cd3cc8cc7.svg";
export { ForwardRef as ReactComponent };